import { FC, Fragment, ReactNode, useEffect, useRef } from "react";
import { useRouter } from "next/router";

interface IProps {
    total: number | string;
    children: ReactNode;
    isMobile: boolean;
}

const InfiniteScroll: FC<IProps> = ({ children, total, isMobile }) => {
    const { query: { page: current = 1, ...query }, push: routerPush, asPath } = useRouter();
    const sentinelRef = useRef<HTMLDivElement | null>(null);
    const observerRef = useRef<IntersectionObserver | null>(null);

    useEffect(() => {
        const handleIntersection = (entries: IntersectionObserverEntry[]) => {
            const entry = entries[0];
            if (entry.isIntersecting) {
                const currPageHandle: () => string = () => {
                    if (!current) return "2";
                    const finalPage: boolean = +current >= +total;
                    if (!finalPage) return String(+current + 1);
                    return String(current);
                };
                if (+current <= +total) {
                    routerPush({ query: { ...query, page: currPageHandle() } }, undefined, { scroll: false, shallow: false });
                }
            }
        };

        observerRef.current = new IntersectionObserver(handleIntersection, {
            root: null,
            rootMargin: isMobile ? '600px' : '900px'
        });

        if (sentinelRef.current) {
            observerRef.current.observe(sentinelRef.current);
        }

        return () => {
            if (observerRef.current && sentinelRef.current) {
                observerRef.current.unobserve(sentinelRef.current);
            }
        };
    }, [current, total, query, routerPush]);

    return (
        <Fragment>
            {children}
            <div ref={sentinelRef} />
        </Fragment>
    );
};

export default InfiniteScroll;
